// extracted by mini-css-extract-plugin
export default {"subscription-link":"SubscriptionLink_subscription-link__8yC4W","img":"SubscriptionLink_img__JA+Ua","icon":"SubscriptionLink_icon__hGJ0x"};